import {
  MutationAzureDevOpsRepoIntegrationCreateArgs,
  MutationAzureDevOpsRepoIntegrationUpdateArgs,
  VcsCheck,
} from "types/generated";
import { ROOT_SPACE_ID } from "constants/space";

import { ManageAzureDevOpsFormFields } from "./types";
import { VCS_INTEGRATION_TYPES } from "../../constants";
import { AzureDevOpsIntegrationData } from "./Edit/gql";

export const getFormDefaultValues = (
  integration?: AzureDevOpsIntegrationData
): ManageAzureDevOpsFormFields => {
  const useGitCheckoutValue = integration ? integration?.useGitCheckout : true;
  return {
    name: integration?.name || "",
    space: integration?.space?.id || "",
    labels: integration?.labels?.map((label) => ({ value: label })) || [],
    accessibleProjects:
      integration?.accessibleProjects?.map((project) => ({ value: project })) || [],
    organizationURL: integration?.organizationURL || "",
    userFacingHost: integration?.userFacingHost || "",
    personalAccessToken: "",
    description: integration?.description || "",
    integrationType: integration?.isDefault
      ? VCS_INTEGRATION_TYPES.DEFAULT
      : VCS_INTEGRATION_TYPES.MULTIPLE,
    vcsChecks: integration?.vcsChecks || VcsCheck.Individual,
    useGitCheckout: useGitCheckoutValue,
    individualFailuresOnly: integration?.vcsCheckOptions?.individualFailuresOnly ?? false,
    individualSkipUnchanged: integration?.vcsCheckOptions?.individualSkipUnchanged ?? false,
  };
};

export const mapCreateAzureDevOpsIntegrationInputValues = (
  values: ManageAzureDevOpsFormFields
): MutationAzureDevOpsRepoIntegrationCreateArgs => {
  const isDefault = values.integrationType === VCS_INTEGRATION_TYPES.DEFAULT;

  return {
    customInput: {
      isDefault,
      name: values.name.trim(),
      labels: values.labels.map((label) => label.value) || [],
      // FYI: set the root to be able to convert to the multiple integration from the default one
      spaceID: isDefault ? ROOT_SPACE_ID : values.space,
      description: values.description?.trim() || null,
      vcsChecks: values.vcsChecks,
      useGitCheckout: values.useGitCheckout,
      vcsCheckOptions: {
        individualFailuresOnly: values.individualFailuresOnly,
        individualSkipUnchanged: values.individualSkipUnchanged,
      },
    },
    organizationURL: values.organizationURL.trim(),
    personalAccessToken: values.personalAccessToken.trim(),
    userFacingHost: values.userFacingHost.trim(),
    accessibleProjects: values.accessibleProjects
      .map((project) => project.value.trim())
      .filter(Boolean),
  };
};

export const mapUpdateAzureDevOpsIntegrationInputValues = (
  values: ManageAzureDevOpsFormFields,
  integrationId: string
): MutationAzureDevOpsRepoIntegrationUpdateArgs => ({
  customInput: {
    id: integrationId,
    labels: values.labels.map((label) => label.value) || [],
    description: values.description?.trim() || null,
    space: values.space,
    vcsChecks: values.vcsChecks,
    useGitCheckout: values.useGitCheckout,
    vcsCheckOptions: {
      individualFailuresOnly: values.individualFailuresOnly,
      individualSkipUnchanged: values.individualSkipUnchanged,
    },
  },
  organizationURL: values.organizationURL.trim(),
  personalAccessToken: values.personalAccessToken?.trim() || null,
  userFacingHost: values.userFacingHost.trim(),
  accessibleProjects: values.accessibleProjects
    .map((project) => project.value.trim())
    .filter(Boolean),
});
